import React from 'react';
import { connect } from 'react-redux';
import { HorizontalBar } from 'react-chartjs-2';

import { Link } from "react-router-dom";
import * as ROUTES from '../../../../../constants/routes';

const AllProjectLimitStats = (props) => {
    const { internalProjectMembersLimit, externalProjectMembersLimit, totalActiveInternalMember, totalActiveExternalMember, commons, projectTagCount, projectTagLimit, tagCount, tagLimit, modalInfoTextStyle,isInternalMember } = props;

    // calculation of limits
    const percentageOfTagCount = Math.round(tagLimit > 0 ? (tagCount / tagLimit) * 100 : 0);
    const percentageOfInternalProjectMembersLimit = Math.round(internalProjectMembersLimit > 0 ? (totalActiveInternalMember / internalProjectMembersLimit) * 100 : 0);
    const percentageOfExternalProjectMembersLimit = Math.round(externalProjectMembersLimit > 0 ? (totalActiveExternalMember / externalProjectMembersLimit) * 100 : 0);
    const percentageOfProjectTagCount = Math.round(projectTagLimit > 0 ? (projectTagCount / projectTagLimit) * 100 : 0);
    // console.log(percentageOfInternalProjectMembersLimit, percentageOfExternalProjectMembersLimit, percentageOfProjectTagCount)

    // progress bar color
    const progressBarColorBasedOnPercentageOfInternalMembersLimit = percentageOfInternalProjectMembersLimit > 0 && percentageOfInternalProjectMembersLimit <= 70 ? "green" : percentageOfInternalProjectMembersLimit > 70 && percentageOfInternalProjectMembersLimit <= 85 ? "Gold" : "OrangeRed";
    const progressBarColorBasedOnPercentageOfExternalMembersLimit = percentageOfExternalProjectMembersLimit > 0 && percentageOfExternalProjectMembersLimit <= 70 ? "green" : percentageOfExternalProjectMembersLimit > 70 && percentageOfExternalProjectMembersLimit <= 85 ? "Gold" : "OrangeRed";
    const progressBarColorBasedOnPercentageOfProjectTagLimit = percentageOfProjectTagCount > 0 && percentageOfProjectTagCount <= 70 ? "green" : percentageOfProjectTagCount > 70 && percentageOfProjectTagCount <= 85 ? "Gold" : "OrangeRed";

    // chartjs2 based slider bars
    const tagData = {
        labels: ['%'],
        datasets: [
            {
                label: `Limit (${tagCount}/${tagLimit !== '-1' ? tagLimit : `${commons.unlimited}`}})`,
                data: [percentageOfTagCount],
                backgroundColor: [
                    'rgba(20, 56, 150, 0.4)',
                ],
                borderColor: [
                    'rgba(20, 56, 150, 1)',
                ],
                borderWidth: 1,
            }
        ],
    };

    const projectTagData = {
        labels: ['%'],
        datasets: [
            {
                label: `Limit (${projectTagCount}/${projectTagLimit !== '-1' ? projectTagLimit : `${commons.unlimited}`}})`,
                data: [percentageOfProjectTagCount],
                backgroundColor: [
                    'rgba(20, 56, 150, 0.4)',
                ],
                borderColor: [
                    'rgba(20, 56, 150, 1)',
                ],
                borderWidth: 1,
            }
        ],
    };

    const projectInternalsData = {
        labels: ['%'],
        datasets: [
            {
                label: `Limit (${totalActiveInternalMember}/${internalProjectMembersLimit !== '-1' ? internalProjectMembersLimit : `${commons.unlimited}`}})`,
                data: [percentageOfInternalProjectMembersLimit],
                backgroundColor: [
                    'rgba(20, 56, 150, 0.4)',
                ],
                borderColor: [
                    'rgba(20, 56, 150, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    const projectExternalsData = {
        labels: ['%'],
        datasets: [
            {
                label: `Limit (${totalActiveExternalMember}/${externalProjectMembersLimit !== '-1' ? externalProjectMembersLimit : `${commons.unlimited}`}})`,
                data: [percentageOfExternalProjectMembersLimit],
                backgroundColor: [
                    'rgba(20, 56, 150, 0.4)',
                ],
                borderColor: [
                    'rgba(20, 56, 150, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        showLines: true,
        // maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            xAxes: [
                {
                    ticks: {
                        // display: false,
                        stepSize: 50,
                        min: 0,
                        max: 100,
                    }
                }
            ]
        }
    }


    return (
        <div className="card p-2" style={{ borderRadius: '15px', overflow: 'auto' }}>
            <div className="card-header bg-white p-0 mx-2 mb-2">
                <div className="row">
                    <div className="col-12">
                        <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Limit tracker</p>
                        <p style={modalInfoTextStyle}>Keep track of {commons.project} limits.</p>
                    </div>
                </div>
            </div>

            {/* Card Body */}
            <div className="card-body">
                <HorizontalBar data={projectTagData} width={100} height={20} options={{
                    ...options, title: {
                        display: true,
                        text: `${commons.uprojectTagUsage}: (${projectTagCount}/${projectTagLimit !== '-1' ? projectTagLimit : `${commons.unlimited}`})`,
                        fontSize: 13,
                    },
                }} />
                <HorizontalBar data={projectInternalsData} width={100} height={20} options={{
                    ...options, title: {
                        display: true,
                        text: `${commons.uinternalMemberUsage}: (${totalActiveInternalMember}/${internalProjectMembersLimit !== '-1' ? internalProjectMembersLimit : `${commons.unlimited}`})`,
                        fontSize: 13,
                    },
                }} />
                <HorizontalBar data={projectExternalsData} width={100} height={20} options={{
                    ...options, title: {
                        display: true,
                        text: `${commons.uexternalMemberUsage}: (${totalActiveExternalMember}/${externalProjectMembersLimit !== '-1' ? externalProjectMembersLimit : `${commons.unlimited}`})`,
                        fontSize: 13,
                    },
                }} />
                <HorizontalBar data={tagData} width={100} height={20} options={{
                    ...options, title: {
                        display: true,
                        text: `${commons.utagUsage}: (${tagCount}/${tagLimit !== '-1' ? tagLimit : `${commons.unlimited}`})`,
                        fontSize: 13,
                    },
                }} />
                {/* If access level is internal link will not be shown */}
                {isInternalMember?<React.Fragment/>:<p style={{ fontSize: '12px' }}><Link to={ROUTES.HOME_COMPANY}>View more about total tag usage in company dashboard</Link></p>}
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        commons: state.commons,
        // styles
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalStyles: state.appControl.modalStyles,
    }
}

export default connect(mapStateToProps)(AllProjectLimitStats)
